var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"sales-bot-map-markers"}},_vm._l((_setup.markers),function(marker,markerIndex){return _c('GmapMarker',{key:markerIndex,attrs:{"position":marker.position,"icon":marker.icon}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }